import styled from 'styled-components';
import AppstoreIcon from '../../assets/icons/appstore.svg?react';
import PlaystoreIcon from '../../assets/icons/playstore.svg?react';
import { Capacitor } from '@capacitor/core';

const Container = styled.div`
  display: flex;
  height: 48px;
  width: 100%;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.text.title};
  border-radius: 999px;
  color: ${({ theme }) => theme.background.primary};
  margin-bottom: 8px;
  margin-top: 8px;
`;

const StoreButton = () => {
  const platform = Capacitor.getPlatform();
  const isAndroid = platform === 'android';
  const isIOS = platform === 'ios';

  const openPlayStore = () => {
    window.open(
      'https://play.google.com/store/apps/details?id=xyz.deks.app',
      '_blank',
    );
  };

  const openAppStore = () => {
    window.open(
      'https://apps.apple.com/us/app/deks-xyz/id6749857801',
      '_blank',
    );
  };

  return (
    <Container
      onClick={() => {
        if (isAndroid) {
          openPlayStore();
        } else if (isIOS) {
          openAppStore();
        }
      }}
    >
      {isAndroid && <PlaystoreIcon height='65%' />}
      {isIOS && <AppstoreIcon height='65%' />}
    </Container>
  );
};

export default StoreButton;
